
import { reject } from 'lodash'

// 字典项公共服务
export function commomDictData (key, object) {
    return new Promise((resolve, reject) => {
        object.$http({
            url: object.$http.adornUrl('/dicDictionary/list'),
            method: 'get',
            params: object.$http.adornParams({
                type: key
             })
        }).then(res => {
            resolve(res)
        }).catch(e => {
            reject(e)
        })
    })
}
